import React from 'react';
import { PhoneAuthenticationForm } from '@vette/ui-components';

export const LoginPage: React.FC = () => {
  return <PhoneAuthenticationForm currentTab="login" />;
};
